// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  adminUserId:['Xn9nWDRPeQdK4XhKEZH7Nvv5IIa2', '0oi7oyGosgfrPPEFGZYJd4ciKL63', 'TW0LZKlTEkPeU2up4L462QVlWtk1'],
 firebaseConfig: {
    apiKey: "AIzaSyB3-DPUysArQUCVR2VTigzUGGuxZFAjiNQ",
    authDomain: "kiokweb.firebaseapp.com",
    databaseURL: "https://kiokweb.firebaseio.com",
    projectId: "kiokweb",
    storageBucket: "kiokweb.appspot.com",
    messagingSenderId: "159582778940",
    appId: "1:159582778940:web:796a24adec206a9d"
  }
/*firebaseConfig: {
     apiKey: "AIzaSyBV3c1Msa-GvFLqM6eZdtr1mKrvm4O0YyE",
     authDomain: "app-backoffice-dev.firebaseapp.com",
    databaseURL: "https://app-backoffice-dev.firebaseio.com",
     projectId: "app-backoffice-dev",
     storageBucket: "app-backoffice-dev.appspot.com",
     messagingSenderId: "900232247520",
     appId: "1:900232247520:web:729e6279966202621eb885"
   }*/
};
